import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: { otherCountry: "Ver catálogo de otro país" },
  en: { otherCountry: "See another country's catalog" },
});
